import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import globalDataReducer from './globalData/globalDataSlice';
import SalaryReducer from '../v2/features/salarycalculator/salary.slice';
import contactReducer from '../v2/features/contact/contact.slice';
import newsReducer from '../v2/features/news/news.slice';
import healthInsuranceReducer from '../v2/features/health-insurance/health-insurance.slice';
import loyaltyReducer from './../v2/features/loyalty/loyalty.slice';
import signupReducer from '../v2/features/signup/signup.slice';
import signinReducer from '../v2/features/signin/signin.slice';
import bankidReducer from '../v2/features/bankid/bankid.slice';
import forgetPasswordReducer from '../v2/features/forget-password/forget-password.slice';
import setNewPasswordReducer from '../v2/features/set-new-password/set-new-password.slice';
import customerReducer from '../v2/features/customer/customer.slice';
import inviteReducer from '../v2/features/invite/invite.slice';
import invoiceReducer from '../v2/features/invoice/invoice.slice';
import userDashboardReducer from '../v2/features/userdashboard/userdashboard.slice';
import invoiceSummaryReducer from '../v2/features/invoicesummary/invoicesummary.slice';
import pieChartReducer from '../v2/features/piechart/piechart.slice';
import analysisReducer from '../v2/features/analysis/analysis.slice';
import chatReducer from '../v2/features/chat/chat.slice';
import organizationReducer from '../v2/features/organization/organization.slice';
import loyaltyStatusReducer from '../v2/features/loyalitystatus/index';
import profileSettingsReducer from '../v2/features/profile-settings/profile-settings.slice';
import invoiceSearchReducer from '../v2/features/invoice-search/invoice-search.slice';
import draftInvoiceReducer from '../v2/features/draft-invoice/draft-invoice.slice';
import timesheetReducer from '../v2/features/timesheet/timesheet.slice';
import employerCertificateReducer from '../v2/features/employer-certificate/employer-certificate.slice';
import employmentContractReducer from '../v2/features/employment-contract/employment-contract.slice';


export const store = configureStore({
  reducer: {
    auth: authReducer,
    globalData: globalDataReducer,
    salary: SalaryReducer,
    contact: contactReducer,
    news: newsReducer,
    healthInsurance: healthInsuranceReducer,
    loyalty: loyaltyReducer,
    signup: signupReducer,
    signin: signinReducer,
    bankidAuthFlow: bankidReducer,
    forgetPassword: forgetPasswordReducer,
    setNewPassword: setNewPasswordReducer,
    customer: customerReducer,
    invite: inviteReducer,
    invoice: invoiceReducer,
    invoiceSearch: invoiceSearchReducer,
    userDashboard: userDashboardReducer,
    invoiceSummary: invoiceSummaryReducer,
    pieChart: pieChartReducer,
    analysis: analysisReducer,
    chat: chatReducer,
    organization: organizationReducer,
    loyalityStatus: loyaltyStatusReducer,
    profileSettings: profileSettingsReducer,
    draftInvoice: draftInvoiceReducer,
    timesheet: timesheetReducer,
    employerCertificate: employerCertificateReducer,
    employmentContract: employmentContractReducer,
  }
});

export default store;
